/*
 * Defect 16: Prestige's <mega-menu-disclosure> crossfades its opacity over 0.4s on close but
 * only 0.25s on open, AND the close of the outgoing panel (when hovering straight from one
 * trigger into an adjacent one) lags the new panel's open by ~100ms+ in practice, regardless of
 * that animation duration. Hovering quickly between adjacent mega-menus (Shop -> Learn) leaves
 * both panels fully open and opaque at once for a perceptible window ("double-exposure"
 * ghosting). The prototype has no crossfade at all (MegaMenu is plain conditional rendering) --
 * this removes Prestige's fade AND force-closes sibling panels the instant a new one opens, so
 * only one panel is ever visible.
 */
/*
 * Viewport clamp (2026-10-19): the panel is centred under its own trigger (assets/jintcm.css), so a wide panel under
 * the first nav item (Shop, now with three columns incl. Gifting) spilled past the left edge of the viewport. Returns
 * the px to shift the centred panel so it stays `margin` inside the viewport; a panel too wide for that aligns left.
 */
function shiftIntoViewport({ triggerCenter, width, viewport, margin }) {
  const left = triggerCenter - width / 2;
  const right = left + width;
  if (left < margin) return margin - left;
  if (right > viewport - margin) return Math.max(viewport - margin - right, margin - left);
  return 0;
}

if (typeof module !== 'undefined' && module.exports) module.exports = { shiftIntoViewport };

if (typeof customElements !== 'undefined') customElements.whenDefined('mega-menu-disclosure').then(() => {
  const MegaMenuDisclosure = customElements.get('mega-menu-disclosure');

  const instantControls = () => ({
    finished: Promise.resolve(true),
    finish() {}
  });

  function closeSiblingsInstantly(openingDisclosure) {
    const nav = openingDisclosure.closest('.header__primary-nav') || document;
    nav.querySelectorAll('mega-menu-disclosure').forEach((sibling) => {
      if (sibling === openingDisclosure) return;
      const details = sibling.querySelector('details.header__menu-disclosure');
      if (details && details.hasAttribute('open')) {
        details.removeAttribute('open');
        details.setAttribute('aria-expanded', 'false');
        details.lastElementChild.style.opacity = '0';
      }
    });
  }

  function clampIntoViewport(disclosure) {
    const panel = disclosure.contentElement;
    const trigger = disclosure.querySelector('details.header__menu-disclosure');
    if (!panel || !trigger) return;
    // --container-gutter is only ~3px on some breakpoints, which would leave the panel touching the viewport edge.
    const gutter = Math.max(parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--container-gutter')) || 0, 16);
    const t = trigger.getBoundingClientRect();
    panel.style.setProperty('--jtcm-mega-shift', shiftIntoViewport({
      triggerCenter: t.left + t.width / 2,
      width: panel.offsetWidth,
      viewport: document.documentElement.clientWidth,
      margin: gutter,
    }) + 'px');
  }

  MegaMenuDisclosure.prototype.createShowAnimationControls = function () {
    closeSiblingsInstantly(this);
    clampIntoViewport(this);
    this.contentElement.style.opacity = '1';
    return instantControls();
  };

  MegaMenuDisclosure.prototype.createHideAnimationControls = function () {
    this.contentElement.style.opacity = '0';
    return instantControls();
  };
});
